<template>
	<ManagingSection class="best-manage" :isTable="true">
		<template slot="infoSection">
			DRAG&DROP 으로 노출순서를 설정하세요. (즉시 반영됨)
		</template>
		<table class="table-main best-table">
			<thead>
				<tr>
					<th
						v-for="item in thList"
						:key="item.id"
						v-text="item.text"
						:class="`best-table__${item.id}`"
					/>
				</tr>
			</thead>
			<tbody v-if="!castList">
				<tr>
					<td
						:colspan="thList.length"
						v-text="'베스크캐스트 목록 불러오는 중...'"
					/>
				</tr>
			</tbody>
			<Draggable
				v-else-if="castList.length"
				v-model="castList"
				tag="tbody"
				@end="endDrag"
			>
				<tr v-for="(item, idx) in castList" :key="item.idPouch">
					<td v-text="idx + 1" class="best-table__order" />
					<td v-text="item.idPouch" class="best-table__id" />
					<td
						v-text="item.pouchCategoryText"
						class="best-table__cate"
					/>
					<td class="best-table__img">
						<img :src="item.fileUrl" class="best-table__img-item" />
					</td>
					<td>
						<router-link :to="`/cast/${item.idPouch}`" class="link">
							{{ item.pouchTitle }}
						</router-link>
					</td>
					<td v-html="item.bestPriod" class="best-table__period" />
					<td v-text="item.productCnt" class="best-table__prd-cnt" />
					<td
						v-text="item.castInterestCount"
						class="best-table__interest-cnt"
					/>
					<td
						v-text="item.castLikeCount"
						class="best-table__like-cnt"
					/>
					<td
						v-text="item.commentCnt"
						class="best-table__comment-cnt"
					/>
					<td class="best-table__stats">
						<button
							v-text="item.hitsCount"
							@click="openAdDailySingleDialog(item.counter.id)"
							class="btn"
						/>
					</td>
					<td>
						<button
							v-text="'삭제'"
							@click="clickDelete(item.idPouch)"
							class="btn red"
						/>
					</td>
				</tr>
			</Draggable>
			<tbody v-else>
				<tr>
					<td
						:colspan="thList.length"
						v-text="'베스크캐스트 목록이 비어있습니다.'"
					/>
				</tr>
			</tbody>
		</table>
		<section data-app>
			<v-dialog
				v-model="dialog_ad_daily_single"
				scrollable
				max-width="400"
			>
				<AdDailySingle :id="selected_ad_id" />
			</v-dialog>
		</section>
	</ManagingSection>
</template>
<script>
	import moment from 'moment';
	import { getImagePath } from '@/util';
	import util from '@/util';
	import Draggable from 'vuedraggable';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import AdDailySingle from '@/components/AdDailySingle.vue';
	import AdService from '@/lib/AdService';

	export default {
		name: 'BestCateSet',
		components: {
			Draggable,
			ManagingSection,
			AdDailySingle,
		},
		data() {
			return {
				thList: [
					{ id: 'order', text: '노출순서' },
					{ id: 'id', text: '번호' },
					{ id: 'cate', text: '카테고리' },
					{ id: 'img', text: '썸네일이미지' },
					{ id: 'title', text: '제목' },
					{ id: 'period', text: '베스트 노출기간' },
					{ id: 'prd-cnt', text: '제품수' },
					{ id: 'interest-cnt', text: '관심' },
					{ id: 'like-cnt', text: '좋아요' },
					{ id: 'comment-cnt', text: '댓글' },
					{ id: 'stats', text: '조회/통계' },
					{ id: 'delete', text: '삭제' },
				],
				castList: null,
				dialog_ad_daily_single: false,
				selected_ad_id: null,
			};
		},
		methods: {
			getLocalStr(time) {
				return moment(time, 'x').format('YYYY-MM-DD HH:mm:ss');
			},
			async getCast() {
				try {
					const params = { offset: 0, limit: 10000 };
					const {
						data: { bestPouchList },
					} = await this.$axiosNoah.get('/pouch/best', { params });
					return bestPouchList;
				} catch (err) {
					console.error(err);
					alert('베스트캐스트 목록을 불러오는데 실패했습니다.');
					return false;
				}
			},
			async deleteCast(id) {
				try {
					await this.$axiosNoah.put(`/pouch/${id}/best?isBest=false`);
				} catch (err) {
					console.error(err);
					alert(
						'베스트캐스트 목록에서 캐스트를 삭제하는데 실패했습니다.'
					);
				}
			},
			async modifyCastOrder() {
				try {
					const length = this.castList.length;
					const items = this.castList.map(({ idPouch }, idx) => ({
						idPouch,
						bestOrderNum: length - idx,
					}));
					await this.$axiosNoah.put('/pouch/best/order-num', {
						items,
					});
				} catch (err) {
					console.error(err);
					alert('순서를 설정하는데 실패했습니다.');
				}
			},
			async setCastList() {
				const list = await this.getCast();
				const { ads } = await AdService.getTargetAdList(
					'GP0038',
					_.map(list, 'idPouch')
				);
				this.castList = list.map(item => ({
					...item,
					fileUrl: getImagePath(item.fileDir, item.fileSaveName),
					bestPriod: `${this.getLocalStr(item.bestStartOn)}<br>~ ${this.getLocalStr(item.bestEndOn)}`,
					productCnt: util.currency(
						String(item.moduleProductCnt || item.productCnt)
					),
					castInterestCount: util.currency(
						String(item.castInterestCount)
					),
					castLikeCount: util.currency(String(item.castLikeCount)),
					commentCnt: util.currency(String(item.commentCnt)),
					hitsCount: util.currency(String(item.hitsCount)),
					counter: _.find(ads, { ref_id: item.idPouch }) || {
						display_count: 0,
						action_count: 0,
					},
				}));
			},
			async clickDelete(id) {
				if (
					!confirm('해당 캐스트를 베스트캐스트에서 삭제하시겠습니까?')
				)
					return;
				await this.deleteCast(id);
				this.setCastList();
			},
			async endDrag() {
				await this.$nextTick();
				await this.modifyCastOrder();
				this.setCastList();
			},
			openAdDailySingleDialog(id) {
				this.selected_ad_id = id;
				this.dialog_ad_daily_single = true;
			},
		},
		watch: {
			dialog_ad_daily_single(v) {
				if (!v) {
					this.selected_ad_id = null;
				}
			},
		},
		created() {
			this.setCastList();
		},
	};
</script>
<style lang="scss" scoped>
	.best-table {
		width: 100%;
		table-layout: fixed;

		&__order {
			width: 64px;
			padding: 0;
			white-space: nowrap;
			font-weight: 700;
		}

		&__id,
		&__prd-cnt,
		&__interest-cnt,
		&__like-cnt,
		&__comment-cnt {
			width: 60px;
			padding: 0;
			white-space: nowrap;
		}

		&__cate {
			width: 180px;
		}

		&__img {
			width: 240px;
		}

		&__img-item {
			max-height: 160px;
		}

		&__period {
			width: 150px;
			padding: 0;
			white-space: nowrap;
		}

		&__stats {
			width: 110px;
			padding: 0;
			white-space: nowrap;
		}

		&__delete {
			width: 70px;
			padding: 0;
			white-space: nowrap;
		}
	}
</style>
